export default {"src":"/_next/static/media/advantages-icon-6.4f164ad9.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};